
const INVALID_INVERSE_QUOTE_CURRENCIES = ['AUD', 'EUR', 'GBP', 'NZD'];
// confirmations take a while to be ready
const CONFIRMATION_DELAY = 5 * 60 * 1000;
export default { 
    INVALID_INVERSE_QUOTE_CURRENCIES,
    CONFIRMATION_DELAY
}